import { useQuery } from "react-query";
import ENDPOINTS from "../../services/endPoints";
import { QueryReturnType } from "../../services/networking.service";

interface IProps {
  page: string | number;
  limit: string | number;
  search: string;
  status?: string;
}

export const useGetOwnerList = ({
  page,
  limit,
  search,
  status,
}: IProps): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.GET_OWNER_LIST, { page, limit, search, status }],
    {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: "always",
      notifyOnChangeProps: [
        "data",
        "error",
        "refetch",
        "isRefetching",
        "isSuccess",
        "isLoading",
      ],
    }
  );
};
